import React, { useState, useEffect } from "react";
import "../style.css";
import {
  FaPhone,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mediaDropdown, setMediaDropdown] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenus = () => {
    setIsMenuOpen(false);
    setMediaDropdown(false);
  };

  // ✅ Home open + scroll top
  const goHomeTop = () => {
    closeMenus();

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const menuItems = [
    // ✅ Home now opens "/" (router) and scrolls top on click
    { name: "Home", link: "/", isRoute: true, onClick: goHomeTop },

    // ✅ These are section anchors (work when you are already on "/")
    { name: "About Us", link: "about-us" },
    { name: "Facilities", link: "facilities" },
    { name: "Neuro Diseases & Symptoms", link: "neuro-section" },
    {
      name: "Media",
      link: "#media",
      dropdown: [
        { name: "Gallery", link: "gallery" },
        { name: "Video", link: "video" },
        { name: "News", link: "rockland-news" },
        { name: "360° View", link: "#media-360-view" },
      ],
    },
    { name: "Blog", link: "blog-section" },
    { name: "Contact Us", link: "contact" },

    // ✅ Appointment route
  ];

  return (
    <>
      {/* Top Contact Bar */}
      <div className="top-contact-bar">
        <div className="contact-container">
          <div className="contact-item">
            <FaPhone className="contact-icon" />
            <span className="contact-text">+91 80903 11155</span>
          </div>
          <div className="contact-divider">|</div>
          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <span className="contact-text">sandy27u@gmail.com</span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          {/* Left Logo (click -> Home + top) */}
          <div className="logo-container">
            <div
              className="logo"
              onClick={goHomeTop}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/logo.png"
                alt="Shree Balaji Travels Logo"
                className="logo-image"
              />
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          {/* Center Navigation Links */}
          <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            {menuItems.map((item, index) => (
              <div
                key={index}
                className={`nav-item ${item.dropdown ? "has-dropdown" : ""}`}
                onMouseEnter={() => item.dropdown && setMediaDropdown(true)}
                onMouseLeave={() => item.dropdown && setMediaDropdown(false)}
              >
                {item.dropdown ? (
                  <>
                    <div className="dropdown-trigger">
                      <a
                        href={item.link}
                        className="nav-link"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <span className="link-text">{item.name}</span>
                        <FaChevronDown className="dropdown-icon" />
                        <span className="link-underline"></span>
                      </a>
                    </div>

                    <div
                      className={`dropdown-menu ${
                        mediaDropdown ? "active" : ""
                      }`}
                    >
                      {item.dropdown.map((subItem, subIndex) => (
                        <a
                          key={subIndex}
                          href={subItem.link}
                          className="dropdown-item"
                          onClick={closeMenus}
                        >
                          <span className="dropdown-text">{subItem.name}</span>
                          <span className="dropdown-underline"></span>
                        </a>
                      ))}
                    </div>
                  </>
                ) : item.isRoute ? (
                  <Link
                    to={item.link}
                    className="nav-link"
                    onClick={() => {
                      if (item.onClick) item.onClick();
                      else closeMenus();
                      // Optional: scroll top for route pages
                      if (!item.onClick) {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    <span className="link-text">{item.name}</span>
                    <span className="link-underline"></span>
                  </Link>
                ) : (
                  <a
                    href={item.link}
                    className="nav-link"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <span className="link-text">{item.name}</span>
                    <span className="link-underline"></span>
                  </a>
                )}
              </div>
            ))}
          </div>

          {/* Right Appointment Button */}
          <div className="appointment-section">
            <button
              className="appointment-btn"
              onClick={() => {
                closeMenus();
                navigate("/appointment");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <span className="btn-text">Book Appointment</span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
